import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const TerminalIcon = createSvgIcon(
  'TerminalIcon',
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="13" height="13" rx="2" fill={Color.Dark300} />
    <path
      d="M8.63293 11.5V5.55752H11.25V4.5H4.75V5.55752H7.37198V11.5H8.63293Z"
      fill={Color.White}
    />
  </svg>,
  { viewBox: '0 0 16 16', style: { width: '16px', height: '16px' } },
);
